import styled from 'styled-components';
import { Button } from '@m/alchemy-ui/Button';
import { Checkbox } from '@m/alchemy-ui/Checkbox';
import { Dialog } from '@m/alchemy-ui/Dialog';
import { units } from '@m/alchemy-ui/theme';

import medalliaSnappySrc from '../../../../assets/images/medallia-snappy.svg';

export const MedalliaSnappyLogo = styled.img.attrs({ src: medalliaSnappySrc })`
  height: 42px;
  margin-bottom: ${units(2)};
  margin-top: ${units(1)};
  width: 170px;
`;

export const InlineBlockCheckbox = styled(Checkbox)`
  display: inline-block;
  margin-top: ${units(1.5)};
`;

export const FlexDialogFooter = styled(Dialog.Footer)`
  display: flex;
`;

export const FooterButton = styled(Button)`
  flex: 1;
  margin: 0 ${units(1)};
`;
